import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

/**
 * Sprint H Batch 2 — Customer auth (cookie httpOnly puro).
 *
 * Cookie: `ag_customer_cookie` (HttpOnly, Secure, SameSite=lax, Max-Age=28d).
 * Sin localStorage, sin Authorization header.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const CustomerAuthContext = createContext(null);

export const customerApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export function CustomerAuthProvider({ children }) {
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    customerApi.get("/customer-auth/me")
      .then(({ data }) => setAccount(data))
      .catch(() => setAccount(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await customerApi.post("/customer-auth/login", { email, password });
    setAccount(data.account);
    return data.account;
  };

  const signup = async (payload) => {
    const { data } = await customerApi.post("/customer-auth/signup", payload);
    setAccount(data.account);
    return data.account;
  };

  const logout = async () => {
    try { await customerApi.post("/customer-auth/logout"); } catch {}
    setAccount(null);
  };

  const refresh = async () => {
    try {
      const { data } = await customerApi.get("/customer-auth/me");
      setAccount(data);
      return data;
    } catch { return null; }
  };

  return (
    <CustomerAuthContext.Provider value={{ account, loading, login, signup, logout, refresh, setAccount }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}

export function useCustomerAuth() {
  return useContext(CustomerAuthContext);
}
